import {
  AccordionSummary,
  AccordionSummaryProps,
  styled,
  useTheme,
} from "@mui/material";

export interface MdmAccordionSummaryProps extends AccordionSummaryProps {
  isExpanded?: boolean | undefined;
}

export function MdmAccordionSummary({
  isExpanded,
  ...otherProps
}: MdmAccordionSummaryProps) {
  const theme = useTheme();
  const bgColor = isExpanded
    ? theme.palette.primary.main
    : theme.palette.background.default;
  return <StyledAccordionSummary {...otherProps} sx={{ bgcolor: bgColor }} />;
}

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  height: "1rem",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));
